var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content railwayStation" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "operations" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("common.btn.query") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "310px" },
                            attrs: {
                              no: "likeName",
                              placeholder: _vm.$t("common.tips.fuzzySearch")
                            },
                            model: {
                              value: _vm.filter.likeName,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "likeName", $$v)
                              },
                              expression: "filter.likeName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "query", size: "mini", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.filter.pageNum = 1
                              _vm.toQuery()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "new", size: "mini", type: "primary" },
                          on: { click: _vm.showAddDialog }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "edit", size: "mini", type: "primary" },
                          on: { click: _vm.showEditDialog }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "delete", size: "mini", type: "danger" },
                          on: { click: _vm.remove }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "grid-params": _vm.girdParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.girdParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.girdParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total>0"
                  }
                ],
                attrs: {
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("station-edit-dialog", {
        attrs: {
          visible: _vm.editDialog.visible,
          title: _vm.editDialog.title,
          "railway-station": _vm.editDialog.railwayStation
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          saveCallBack: _vm.editDialog.saveCallBack,
          close: function($event) {
            _vm.editDialog.visible = false
          }
        }
      }),
      _c("select-station-template-list-dialog", {
        attrs: { visible: _vm.templateListDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateListDialog, "visible", $event)
          },
          addCallBack: _vm.templateListDialog.addCallBack,
          close: function($event) {
            _vm.templateListDialog.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }